$('body').addClass('hypothesis-14-cart-nudges');
// get the current path
const currentPath = window.location.pathname.split('/')[1];
console.log(currentPath); // e.g., 'nl', 'de', etc.
window.currentPath = currentPath;
// Function to get a cookie by name
function getCookie(name) {
const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
return match ? decodeURIComponent(match[2]) : null;
}
// Function to set a cookie with expiration in minutes
function setCookie(name, value, minutes) {
const d = new Date();
d.setTime(d.getTime() + (minutes * 60 * 1000));
const expires = "expires=" + d.toUTCString();
document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
}

// Function to determine if popup should be shown based on last shown time
function shouldShowPopup() {
const timestamp = getCookie("cro-welcome");
if (!timestamp) return true; // First time visit

const lastShown = parseInt(timestamp, 10);
const now = Math.floor(Date.now() / 1000);

// Show only if 10 minutes (600 seconds) have passed
return (now - lastShown) > 600;
} 

if (shouldShowPopup()) {
const path = `${window.location.origin}/cart?view=cro-welcome-back`;
fetch(path)
.then(response => {
    if (!response.ok) {
    throw new Error('Network response was not ok');
    }
    return response.text(); // We're expecting HTML as text
})
.then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    // Modify this selector to match your product item wrapper
    const products = doc.querySelectorAll('.cart-item'); // Replace with your actual product selector
    const firstThreeProducts = Array.from(products).slice(0, 3);

    // Find the popup container
    const popupContainer = document.querySelector('.custom-cro-popup.custom-popup--right.custom-cropopup--welcome');

    if (popupContainer && products.length > 0) {
        popupContainer.appendChild(doc.querySelector(".custom-popup__wrapper"));
        popupContainer.style.display = "block";
        popupContainer.style.opacity = 1;
        setCookie("cro-welcome", Math.floor(Date.now() / 1000), 10);

        // Detect country and cart data
        const cartData = window.jimmyjoy?.cart;
        if (!cartData) {
        console.warn('Missing country or cart data');
        } else {
        const cartTotalCents = Number(cartData.total_price) || 0;
        const cartTotalEuros = cartTotalCents / 100;
        console.log(cartTotalEuros,"cartTotalEuros");
        
        let FREE_SHIPPING_THRESHOLD_CUSTOM = 75;



        // Only call update if country is in either list
        if (FREE_SHIPPING_THRESHOLD_CUSTOM !== undefined) {
            updateFreeShippingBar(cartTotalEuros, FREE_SHIPPING_THRESHOLD_CUSTOM);
        } else {
            console.log('Country not eligible for free shipping threshold');
        }
    document.querySelector('.custom-cropopup--welcome').addEventListener('click', function() {
        const popup = document.querySelector('.custom-cro-popup.custom-popup--right.custom-cropopup--welcome');
        if (popup) {
            popup.style.transition = "opacity 0.2s ease";
            popup.style.opacity = 0;
            setTimeout(() => popup.style.display = "none", 200);
        }
        });
        }

        // Your update function (assuming defined somewhere)
        function updateFreeShippingBar(total, threshold) {
            
        const fill = document.getElementById('progress-fill');
        const message = document.getElementById('shipping-message');

        const progress = Math.min((total / threshold) * 100, 100);
        fill.style.width = `${progress}%`;

        const remaining = threshold - total;

        if (remaining > 0) {
           message.textContent = `Spend $${remaining.toFixed(2)} more to get free shipping!`;
        } else {
            message.textContent = `Great news! You get FREE SHIPPING!`;
            document.querySelector(".custom-cro-popup .popup_image").classList.remove("hidden");
        }
        document.querySelector("#free-shipping-bar").style.display = "block";
        }
    } else {
    console.warn('Popup container not found');
    }
})
.catch(error => {
    console.error('Fetch error:', error);
});
}